import { ChipClassKey, StyleRules } from "@material-ui/core";
import { Colors } from "style/Colors";

export const MuiChip: Partial<StyleRules<ChipClassKey, {}>> = {
  outlinedSecondary: {
    color: Colors.greenLight,
    border: `1px solid ${Colors.greenLight}`,
  },
};
